// TODO(LNS-185): Convert all utils to ts
import { getColorValue } from './color';

// Type
export const getTextSize = size =>
  size &&
  `
  font-size: var(--lns-fontSize-${size});
  line-height: var(--lns-lineHeight-${size});
  letter-spacing: var(--lns-letterSpacing-${size});
`;

export const getFontWeight = fontWeight =>
  fontWeight && `font-weight: var(--lns-fontWeight-${fontWeight});`;

export const getFontSetting = fontSetting =>
  fontSetting && `var(--lns-fontSetting-${fontSetting});`;

export const getRadius = size =>
  size && `border-radius: var(--lns-radius-${size});`;

export const getShadow = size =>
  size && `box-shadow: var(--lns-shadow-${size});`;

export const getFocusRing = (color?: string, position?: string) => {
  const focusColor = color ? color : getColorValue('focusRing');

  return `box-shadow:${position ? position : ''} 0 0 0 2px ${focusColor};`;
};

// Use for elements who have background colour. The standard focus ring does
// not provide sufficient contrast against most variant bg colours.
export const getOffsetFocusRing = (color?: string) => {
  const focusColor = color ? color : getColorValue('focusRing');

  return `
  outline: 2px solid ${focusColor};
  outline-offset: 1px;
  `;
};

export const getListContainer = tag => {
  if (tag === 'ol' || tag === 'ul') {
    return `
      list-style-type: none;
      margin: 0;
      padding: 0
      `;
  }
};

export const getPlacement = (maxHeight, placement) => {
  const placementStyles = {
    center: {
      bottom: 0,
      top: `calc((100vh - ${maxHeight}) / 2)`,
      position: 'relative',
    },
    bottom: {
      bottom: 0,
      top: 'unset',
      position: 'absolute',
    },
    undefined: {
      bottom: undefined,
      top: '15vh',
      position: 'relative',
    },
  };

  return placementStyles[placement];
};
